import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["listStyleReset"];
import React from 'react';
import { spacer32 } from '@spotify-internal/encore-foundation';
import styled, { css } from 'styled-components';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.js";
import { rootStyle } from "../../styles/index.js";
var TypeListElement = styled.ul.attrs(function (props) {
  return {
    role: props.role || 'list',
    listStyleReset: props.listStyleReset || false
  };
}).withConfig({
  displayName: "TypeList__TypeListElement",
  componentId: "sc-1jhixr6-0"
})(["", ";padding-inline-start:", ";padding-inline-end:0;padding-block-end:", ";margin-block-start:0;margin-block-end:0;overflow-wrap:break-word;", ";"], rootStyle(), function (props) {
  return props.condensedAll ? '0' : spacer32;
}, function (props) {
  return props.condensed && '0';
}, function (props) {
  return props.listStyleReset !== false && css(["list-style-type:none;"]);
});
var typeListHelpers = {
  ul: TypeListElement.withComponent('ul'),
  ol: TypeListElement.withComponent('ol')
};
var TypeListComponent = /*#__PURE__*/React.forwardRef(function TypeList(_ref, ref) {
  var _ref$listStyleReset = _ref.listStyleReset,
    listStyleReset = _ref$listStyleReset === void 0 ? false : _ref$listStyleReset,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(TypeListElement, Object.assign({}, props, {
    ref: ref,
    listStyleReset: listStyleReset,
    "data-encore-id": ENCORE_DATA_IDS.TypeList
  }));
});

/**
* **TypeList** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TypeList) 
*
* null
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/type?format=figma-figma#list-text)
*
* @example
* () => (
*  <TypeList>
*    <TypeListItem>
*      Aenean lacinia bibendum nulla sed consectetur. Lorem ipsum dolor sit amet, consectetur
*      adipiscing elit.
*    </TypeListItem>
*    <TypeListItem>
*      Cras justo odio, dapibus ac facilisis in, egestas eget quam. Duis mollis, est non commodo
*      luctus.
*    </TypeListItem>
*    <TypeListItem condensed>
*      Condensed item - Etiam porta sem malesuada magna mollis euismod.
*    </TypeListItem>
*  </TypeList>
*);
*
*/
export var TypeList = Object.assign(TypeListComponent, typeListHelpers);